import { cn, Skeleton } from '@/core/ui';

export function RecordItemSkeleton({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'flex flex-col group relative',
        'shrink-0',
        'bg-content1',
        'rounded-lg',
        'border border-default-200',
        'hover:border-default-300',
        'transition-all duration-300',
        'shadow-sm backdrop-blur-xl',
        className,
      )}
    >
      <div className='p-3 space-y-3'>
        {/* Header */}
        <div className='flex items-center justify-between'>
          <div className='flex items-center gap-2'>
            <Skeleton className='h-4 w-6 rounded' />
            <Skeleton className='h-4 w-28 rounded' />
          </div>
          <Skeleton className='h-2 w-5 rounded-md' />
        </div>
        {/* Question */}
        <Skeleton className='h-4 w-3/4 rounded' />
        {/* Status/Remarks/Date Row */}
        <div className='flex items-center gap-1'>
          <Skeleton className='h-5 w-6 rounded' />
          <Skeleton className='h-5 w-20 rounded' />
          <Skeleton className='h-5 w-8 rounded' />
          <div className='flex-1 flex justify-end'>
            <Skeleton className='h-3 w-16 rounded' />
          </div>
        </div>

        <div className='flex items-center gap-1'>
          <Skeleton className='h-4 w-28 rounded' />
          <div className='flex-1 flex justify-end'>
            <Skeleton className='h-4 w-16 rounded' />
          </div>
        </div>
      </div>
    </div>
  );
}
